import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 49 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M24.762 48.001c13.386 0 24.238-10.745 24.238-24S38.148 0 24.762 0C11.375 0 .523 10.746.523 24c0 13.256 10.852 24.001 24.239 24.001" }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.27 10.145h12.989c4.173 0 7.605 3.398 7.605 7.53v12.796c0 4.132-3.432 7.53-7.605 7.53h-12.99c-4.173 0-7.605-3.398-7.605-7.53V17.675c0-4.132 3.432-7.53 7.605-7.53m14.065 4.863c.875 0 1.615.733 1.615 1.6 0 .866-.74 1.6-1.615 1.6a1.586 1.586 0 0 1-1.615-1.6c0-.867.672-1.6 1.615-1.6m-7.606 1.467h.067c4.174 0 7.673 3.465 7.673 7.598 0 4.198-3.5 7.597-7.673 7.597h-.067c-4.173 0-7.605-3.398-7.605-7.597 0-4.132 3.432-7.598 7.605-7.598m0 2.599h.067c2.76 0 5.047 2.265 5.047 4.997 0 2.8-2.288 5.065-5.047 5.065h-.067c-2.76 0-5.047-2.265-5.047-5.064 0-2.733 2.288-4.998 5.047-4.998m-6.394-6.53H31.19c2.894 0 5.25 2.332 5.25 5.198v12.662c0 2.866-2.356 5.198-5.25 5.198H18.335c-2.894 0-5.25-2.332-5.25-5.198V17.742c0-2.866 2.356-5.198 5.25-5.198",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }